import { Component, Injector } from '@angular/core';
import { LoaderService, MessageService, ObjectHelper } from '@shared';
import { TierAware } from '../tier-aware.component';
import { Configuration, Tier } from '../../models';
@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrl: './configuration.component.scss',
})
export class ConfigurationComponent extends TierAware {
  showApply: boolean = false;

  warnings: { [key: string]: string } = {};

  formatMap: { [formatKey: string]: string } = {
    p: '%',
  };

  tier!: Tier;

  originalTier!: Tier;

  updateAll: boolean = false;

  constructor(
    injector: Injector,
    private loaderService: LoaderService,
    private messageService: MessageService,
  ) {
    super(injector);
  }

  override afterTierChange(tier: Tier) {
    this.originalTier = tier;
    this.tier = ObjectHelper.deepCopy(tier);
  }

  applyChanges() {
    this.loaderService.show();

    this.tierService
      .updateTierConfiguration(
        this.tier.id,
        ObjectHelper.deepCopy(this.tier),
        this.updateAll,
      )
      .subscribe({
        next: () => {
          this.globalEventsService.updateTiers();

          this.loaderService.hide();

          this.showApply = false;
        },
        error: (err) => {
          this.messageService.error(err);

          this.loaderService.hide();

          this.showApply = false;
        },
      });
  }

  cancelApply() {
    this.showApply = false;
  }

  hasChanged() {
    return JSON.stringify(this.tier) !== JSON.stringify(this.originalTier);
  }

  toggleConfiguration(configuration: Configuration, value: boolean) {
    configuration.is_active = value;

    if (configuration.children) {
      configuration.children.forEach((child) => {
        this.toggleConfiguration(child, value);
      });
    }
  }
}
